<div class="mt-3">
  <p-accordion class="w-full" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
    @for (doc of docs; track $index) {
      <p-accordion-panel [value]="$index">
        <p-accordion-header>
          <span class="flex align-items-center gap-2 w-full">
            <i [class]="doc.icon"></i>
            <span class="font-bold white-space-nowrap">{{ doc.title | translate }}</span>
          </span>
        </p-accordion-header>
        <p-accordion-content>
          <div class="document-content">
            @for (section of doc.sections; track $index) {
              <div [class]="getSectionClasses(section)">
                @switch (section.type) {
                  @case ('title') {
                    <h2 class="document-title" [class]="getColorClass(section.color)">
                      {{ section.translationKey ? (section.translationKey | translate) : section.content }}
                    </h2>
                  }
                  @case ('subtitle') {
                    <h5 class="document-subtitle" [class]="getColorClass(section.color)" style="text-decoration: underline;">
                      {{ section.translationKey ? (section.translationKey | translate) : section.content }}
                    </h5>
                  }
                  @case ('text') {
                    <p class="document-text" [innerHTML]="section.translationKey | translate"></p>
                  }
                  @case ('link') {
                    <button
                      class="document-link"
                      [class]="getColorClass(section.color)"
                      (click)="onDownload(section.url!)"
                      type="button">
                      <i class="pi pi-download mr-2"></i>
                      {{ section.translationKey ? (section.translationKey | translate) : section.content }}
                    </button>
                  }
                  @case ('warning') {
                    <div class="document-warning" [class]="getColorClass(section.color)">
                      <i class="pi pi-exclamation-triangle mr-2"></i>
                      {{ section.translationKey ? (section.translationKey | translate) : section.content }}
                    </div>
                  }
                  @case ('note') {
                    <div class="document-note">
                      <strong>{{ section.translationKey ? (section.translationKey | translate) : section.content }}</strong>
                    </div>
                  }
                  @case ('list') {
                    <ul class="document-list">
                      @for (item of section.items!; track $index) {
                        <li class="document-list-item">
                          <strong [class]="getColorClass(item.color)">
                            {{ item.titleKey ? (item.titleKey | translate) : item.title }}
                          </strong>
                          {{ item.contentKey ? (item.contentKey | translate) : item.content }}
                        </li>
                      }
                    </ul>
                  }
                }
              </div>
            }
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    }
  </p-accordion>
</div>